import {createActions} from 'reduxsauce';

export const {Types: DownloadTypes, Creators: DownloadActionCreators} = createActions ({
    downloadStart: ['orderId'],
    downloadSuccess: ['data'],
    downloadFailure: ['error'],
});